/**
 * Returns a random number between a range
 * @param {Integer} min The minimum number
 * @param {Integer} max The maximum number
 * @returns {Integer} The random number
 */
const getRandomInteger = ( min = 0, max = Number.MAX_SAFE_INTEGER ) => {
    return Math.floor( Math.random() * ( max - min + 1 ) ) + min;
}

export default getRandomInteger;
